import React, { createElement, useState, Fragment, useRef } from 'react';
import Player from '@ifeng-fe/three_terminal/es/pc/video/output/pcVideo.jsx';
import md5 from 'md5';
import Style from './index.module.scss';
import { Mask } from '@ifeng-fe/lowcode_tool/src/components/Mask';
import { useChip, TYPE_Chip } from '@ifeng-fe/lowcode_tool/src/hooks/useChip';
import { formatChip } from '@ifeng-fe/lowcode_tool/src/method/chip';
import Chip from 'Chip';
import { Swiper } from 'swiper/esm/react/swiper.js';
import { SwiperSlide } from 'swiper/esm/react/swiper-slide.js';
import SwiperCore, { Navigation } from 'swiper';
import 'swiper/swiper.scss';
import { formatImage } from '@ifeng-fe/public_method';

SwiperCore.use([Navigation]);

export interface VideoList_2_Props {
    videoChip: TYPE_Chip;
    __designMode: string;
    nodeId?: string;
    style?: object;
    width: number; // 播放器宽
    height: number; // 播放器高
    controls: boolean; // 是否显示播放控件

    // 新增
    videoArrowShow: boolean;
    videoArrowBtnPrev: string;
    videoArrowPrevHover: string;
    videoArrowNext: string;
    videoArrowNextHover: string;
    videoArrowWidth: number;
    videoArrowHeight: number;
    videoArrowX: number;
    videoArrowY: number;

    slidesPerView: number;
    listArrowShow: boolean;
    listArrowPrev: string;
    listArrowPrevHover: string;
    listArrowNext: string;
    listArrowNextHover: string;
    listArrowWidth: number;
    listArrowHeight: number;
    listArrowX: number;
    listArrowY: number;
    itemStyle: object;
    itemCurrentStyle: object;
    itemThumbWidth: number;
    itemThumbHeight: number;
    showItemTitle: boolean;
}

const VideoList_2: React.FC<VideoList_2_Props> = (props) => {
    const {
        nodeId,
        style,
        width,
        height,
        controls,
        videoChip,
        __designMode,
        videoArrowShow,
        videoArrowBtnPrev,
        videoArrowPrevHover,
        videoArrowNext,
        videoArrowNextHover,
        videoArrowWidth,
        videoArrowHeight,
        videoArrowX,
        videoArrowY,

        slidesPerView,
        listArrowShow,
        listArrowPrev,
        listArrowPrevHover,
        listArrowNext,
        listArrowNextHover,
        listArrowWidth,
        listArrowHeight,
        listArrowX,
        listArrowY,
        itemStyle,
        itemCurrentStyle,
        itemThumbWidth,
        itemThumbHeight,
        showItemTitle,
    } = props;

    const playList = useChip(videoChip);
    const playListChipComponentData = formatChip(videoChip);

    const [playIndex, setPlayIndex] = useState(0);

    const swiperRef = useRef();

    const [isVideoHoverLeft, setIsVideoHoverLeft] = useState(false);
    const [isVideoHoverRight, setIsVideoHoverRight] = useState(false);
    const [isListHoverLeft, setIsListHoverLeft] = useState(false);
    const [isListHoverRight, setIsListHoverRight] = useState(false);

    const handleVideoPrevClick = () => {
        setPlayIndex(playIndex - 1 < 0 ? playList.length - 1 : playIndex - 1);
    };

    const handleVideoNextClick = () => {
        setPlayIndex(playIndex + 1 > playList.length - 1 ? 0 : playIndex + 1);
    };

    const handleListPrevClick = () => {
        // @ts-ignore
        swiperRef.current.slidePrev();
    };

    const handleListNextClick = () => {
        // @ts-ignore
        swiperRef.current.slideNext();
    };

    const getKey = () => {
        return md5(JSON.stringify({ ...props, playList, playIndex }));
    };

    const play = (index) => {
        setPlayIndex(index);
    };

    return (
        <Chip {...playListChipComponentData}>
            <div
                id={nodeId}
                className={Style.wrap}
                style={{
                    ...{ width: `${width}px` },
                    ...style,
                }}
            >
                {playList.length ? (
                    <Fragment>
                        <div className={Style.player}>
                            <Player
                                key={getKey()}
                                videoConfig={playList[playIndex]}
                                playermsg={{
                                    width,
                                    height,
                                    controls,
                                }}
                            />
                            {videoArrowShow && (
                                <React.Fragment>
                                    <img
                                        style={{
                                            width: `${videoArrowWidth}px`,
                                            height: `${videoArrowHeight}px`,
                                            top: `${videoArrowY}px`,
                                            left: `${videoArrowX}px`,
                                        }}
                                        className={Style.videoPrev}
                                        src={
                                            isVideoHoverLeft
                                                ? videoArrowPrevHover || videoArrowBtnPrev
                                                : videoArrowBtnPrev
                                        }
                                        alt=""
                                        onMouseEnter={() => setIsVideoHoverLeft(true)}
                                        onMouseLeave={() => setIsVideoHoverLeft(false)}
                                        onClick={handleVideoPrevClick}
                                    />
                                    <img
                                        style={{
                                            width: `${videoArrowWidth}px`,
                                            height: `${videoArrowHeight}px`,
                                            top: `${videoArrowY}px`,
                                            right: `${videoArrowX}px`,
                                        }}
                                        className={Style.videoNext}
                                        src={
                                            isVideoHoverRight
                                                ? videoArrowNextHover || videoArrowNext
                                                : videoArrowNext
                                        }
                                        alt=""
                                        onMouseEnter={() => setIsVideoHoverRight(true)}
                                        onMouseLeave={() => setIsVideoHoverRight(false)}
                                        onClick={handleVideoNextClick}
                                    />
                                </React.Fragment>
                            )}
                        </div>
                        {playList.length > 2 ? (
                            <div
                                className={Style.playList}
                                style={{
                                    paddingLeft: listArrowWidth,
                                    paddingRight: listArrowWidth,
                                }}
                            >
                                <Swiper
                                    initialSlide={0}
                                    loop={false}
                                    slidesPerView={slidesPerView}
                                    simulateTouch={__designMode !== 'design'}
                                    onSwiper={(swiper) => {
                                        swiperRef.current = swiper;
                                    }}
                                >
                                    {playList.map((item, index) => {
                                        const { title, posterUrl } = item;

                                        return (
                                            <SwiperSlide key={index}>
                                                <div
                                                    className={Style.playItem}
                                                    onClick={() => play(index)}
                                                >
                                                    <div
                                                        className={Style.playItemContent}
                                                        style={{
                                                            width: itemThumbWidth,
                                                            ...itemStyle,
                                                            ...(index === playIndex
                                                                ? itemCurrentStyle
                                                                : {}),
                                                        }}
                                                    >
                                                        <div className={Style.thumbnail}>
                                                            <img
                                                                src={formatImage(
                                                                    posterUrl,
                                                                    itemThumbWidth,
                                                                    itemThumbHeight,
                                                                )}
                                                                alt=""
                                                            />
                                                        </div>
                                                        {showItemTitle && (
                                                            <div className={Style.itemTitle}>
                                                                {title}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        );
                                    })}
                                </Swiper>
                                {listArrowShow && (
                                    <React.Fragment>
                                        <img
                                            style={{
                                                width: `${listArrowWidth}px`,
                                                height: `${listArrowHeight}px`,
                                                top: `${listArrowY}px`,
                                                left: `${listArrowX}px`,
                                            }}
                                            className={Style.listPrev}
                                            src={
                                                isListHoverLeft
                                                    ? listArrowPrevHover || listArrowPrev
                                                    : listArrowPrev
                                            }
                                            alt=""
                                            onMouseEnter={() => setIsListHoverLeft(true)}
                                            onMouseLeave={() => setIsListHoverLeft(false)}
                                            onClick={handleListPrevClick}
                                        />
                                        <img
                                            style={{
                                                width: `${listArrowWidth}px`,
                                                height: `${listArrowHeight}px`,
                                                top: `${listArrowY}px`,
                                                right: `${listArrowX}px`,
                                            }}
                                            className={Style.listNext}
                                            src={
                                                isListHoverRight
                                                    ? listArrowNextHover || listArrowNext
                                                    : listArrowNext
                                            }
                                            alt=""
                                            onMouseEnter={() => setIsListHoverRight(true)}
                                            onMouseLeave={() => setIsListHoverRight(false)}
                                            onClick={handleListNextClick}
                                        />
                                    </React.Fragment>
                                )}
                            </div>
                        ) : null}
                    </Fragment>
                ) : null}
                <Mask visible={!videoChip.id} zIndex={3}>
                    示例推荐位碎片—{videoChip.default.id}
                </Mask>
            </div>
        </Chip>
    );
};

export default VideoList_2;
